import { safeLatOrLong } from '@lib/geo/safeLatOrLong';
import { ICoordinates } from '@app-types/geo';
import { IWeatherDaily } from '@domain/weather/types';

import { returnJsonOrThrow, get } from './shared';

export const getDailyWeatherForecast = async (
  position: ICoordinates,
  daysAhead: number,
  startToday: boolean,
): Promise<IWeatherDaily> => {
  const latitude = safeLatOrLong(position.latitude);
  const longitude = safeLatOrLong(position.longitude);
  const hoursAhead = daysAhead * 24;
  const hoursBehind = startToday ? 24 : 1;

  const response = await get(
    encodeURI(
      `/maps/${latitude},${longitude}/daily_weather_forecast?hours_ahead=${hoursAhead}&hours_behind=${hoursBehind}`,
    ),
    async () => Promise.resolve(null), // no auth token needed
  );
  return returnJsonOrThrow(response);
};
